<template>
  <vx-card
    title="Maps"
    class="mt-base"
  >
    <div class="map-container">
      <vs-input
        class="w-full mb-5"
        label="Type Bussiness Name or Address"
        v-model="data.maps.q"
      />
      <div class="maps-wrapper">
        <iframe
          class="maps"
          height="400"
          width="100%"
          frameborder="0"
          style="border:0"
          :src="`https://www.google.com/maps/embed/v1/place?key=${apiKey}
            &q=${computedMapsQ}`"
          allowfullscreen
        ></iframe>
      </div>
    </div>

  </vx-card>

</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    apiKey () {
      return process.env.VUE_APP_MAPS_API;
    },
    mapsQuery: {
      get() { if(this.data && this.data.maps && this.data.maps.q) { return this.data.maps.q } else { return this.data.name } },
      set($event) {
        this.data.maps.q = $event
      }
    },
    computedMapsQ() {
      return this.mapsQuery ? this.mapsQuery.replace(/[\W_]+/g,"+") : this.mapsQuery
    }
  }
}
</script>

<style lang="scss" scoped>
.map-wrapper {
  overflow: hidden;
  padding-bottom: 56.25%;
  position: relative;
  // height: 0;

  iframe.maps {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
}
</style>
